import BaseApi from '../base/apiBase.service';

export default class InterestedService extends BaseApi {
  constructor(args) {
    super(args);

    this.serviceEndpoints = {
      baseUrl: process.env.REACT_APP_BACKEND_URL,
      get: '/api/interested',
      create: '/api/interested/',
      update: '/api/interested/',
    };
  }

  async getByParameters(data) {
    return super.getByParameters(data);
  }

  async get(data) {
    return super.get(data, '/api/interested/');
  }

  async create(data) {
    return super.create(data);
  }

  async update(data) {
    return super.update(data);
  }
}
